import { createFeatureSelector, createSelector } from '@ngrx/store';

import { selectPropertiesLoading } from '@portfolio/store/portfolio.selectors';

import * as fromManagements from './management.reducer';

export const selectManagementState = createFeatureSelector<fromManagements.ManagementState>(
  fromManagements.managementFeatureKey
);

export const selectThresholdSectionProperty = createSelector(
  selectManagementState,
  managementState => managementState.thresholdSectionProperty
);
export const selectThresholdSectionPropertyLoading = createSelector(
  selectManagementState,
  managementState => managementState.thresholdSectionPropertyLoading
);
export const selectThresholdSectionTask = createSelector(
  selectManagementState,
  managementState => managementState.thresholdSectionTask
);
export const selectThresholdSectionTaskLoading = createSelector(
  selectManagementState,
  managementState => managementState.thresholdSectionTaskLoading
);
export const selectThresholdUpdateLoading = createSelector(
  selectManagementState,
  managementState => managementState.thresholdUpdateLoading
);
export const selectRenewalTargetList = createSelector(
  selectManagementState,
  managementState => managementState.renewalTargetList
);
export const selectRenewalTargetListLoading = createSelector(
  selectManagementState,
  selectPropertiesLoading,
  (managementState, propertiesLoading) => managementState.renewalTargetListLoading || propertiesLoading
);

export const selectCreateCustomFieldLoading = createSelector(
  selectManagementState,
  state => state.createCustomFieldLoading
);

export const selectDeleteCustomFieldLoading = createSelector(
  selectManagementState,
  state => state.deleteCustomFieldLoading
);

export const selectCustomFields = createSelector(selectManagementState, state => state.customFields);

export const selectCustomFieldsLoading = createSelector(selectManagementState, state => state.customFieldsLoading);

export const selectUpdateCustomFieldLoading = createSelector(
  selectManagementState,
  state => state.updateCustomFieldLoading
);

export const selectCustomFieldByContextId = (contextId: number) =>
  createSelector(selectManagementState, state => state.CustomFieldByContextId?.[contextId] ?? []);

export const selectCustomFieldByContextIdLoading = createSelector(
  selectManagementState,
  state => state.CustomFieldByContextIdLoading
);

export const selectTemplatePlaceholders = createSelector(
  selectManagementState,
  managementState => managementState.templatePlaceholders
);

export const selectTemplatePlaceholdersLoading = createSelector(
  selectManagementState,
  managementState => managementState.templatePlaceholdersLoading
);

export const selectTemplatePlaceholdersLoaded = createSelector(
  selectManagementState,
  managementState => managementState.templatePlaceholdersLoaded
);
